module.exports = __webpack_public_path__ + "img/icon_left_4.8495a9d2.png";